import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AiChatPage } from "@/features/ai";

export const Route = createFileRoute("/ai/")({
  component: () => (
    <PermissionGuard module="conversations">
      <AiChatPage />
    </PermissionGuard>
  ),
});
